import {useQuery} from '@tanstack/react-query';
import {QUERY_KEYS} from 'infra/libs/react-query/queryKeys';
import {postIncomeTaxDetails} from '../../services/postIncomeTaxDetails';

export const usePostIncomeTaxDetailsMutation = (year?: string) =>
	useQuery({
		queryKey: [QUERY_KEYS.INCOME_TAX_DETAILS, year],
		queryFn: async ({signal}) => postIncomeTaxDetails({ano: year!, signal}),
		enabled: !!year,
	});
